import {Button} from "@varymadellc/my-weed-club-component-library";
import Page from "@/layout/Page";

export interface BrandsProps {
}

export default function Brands({}: BrandsProps) {
    return (
        <Page title="Welcome to MyWeed.Club">
            <div className="flex flex-col w-10/12 mx-auto items-center">
                <p>🥰 Welcome to MyWeed.Club! We&apos;re thrilled to connect with passionate cannabis brands like yours. Your commitment to excellence and innovation inspires us daily.</p>

                <p>We understand that every brand has a unique story and needs. That&apos;s why we&apos;re here to help you successfully engage with your consumers. MyWeed.Club offers a powerful suite of features designed specifically for brands like yours.</p>
                <br/>
                <p>Here&apos;s why you should consider joining MyWeed.Club:</p>
                <ul>
                    <li>🌿 <strong>Exposure</strong>: Gain exposure for your cannabis products and services within our community of enthusiastic cannabis users.</li>
                    <li>🤝 <strong>Community Engagement</strong>: Connect directly with your target audience, gather valuable feedback, and foster lasting relationships with your customers.</li>
                    <li>📣 <strong>Marketing Opportunities</strong>: Promote your brand through our platform, including sponsored content, featured listings, and more.</li>
                    <li>🌐 <strong>Online Presence</strong>: Establish and enhance your online presence with a dedicated brand profile.</li>
                </ul>

                <br/>
                <p>At MyWeed.Club, we work closely with brands to ensure your success:</p>

                <ul>
                    <li>💬 <strong>Community Interaction</strong>: Engage with the community through the virtual lounge, interact with live members, and get anonymous feedback to better understand their needs and preferences.</li>
                    <li>📣 <strong>Promotion</strong>: Utilize our advertising and promotional tools to boost your brand&apos;s visibility and reach.</li>
                    <li>🔍 <strong>User Feedback</strong>: Receive direct feedback from users to refine your products and services.</li>
                    <li>🤝 <strong>Collaborations</strong>: Explore exciting collaboration opportunities with influencers and fellow brands to expand your reach.</li>
                </ul>
                <br/>
                <p>Ready to get started? Join MyWeed.Club today and unlock the incredible potential to grow your brand within the vibrant cannabis community!</p>

                <Button className="w-4/12 mx-auto" onClick={() => window.location.href = '/signup'}>Sign Up Now</Button>
                <br/>
            </div>
        </Page>
    );
}